import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PublicResource = () => {
  const [message, setMessage] = useState('');

  

  useEffect(() => {
    
    
    /* const token = sessionStorage.getItem('jwtToken'); 
    console.log('JWT token retrieved:', token); */

    // Make an HTTP GET request to the backend API
    const apiUrl = process.env.REACT_APP_API_URL;
    // axios.get('`${apiUrl}`/users/publicresource')
    console.log('API URL: ',apiUrl, '/users/publicresource');
    axios.get('https://muvitapp.com/webapp/', {timeout: 5000})
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  return (
    <div>
      <h1>Message from Backend: {message}</h1>
    </div>
  );
};

export default PublicResource;
